import { useEffect, useRef, useState } from "react"

/*
 * Any button press disables the panel's buttons for two seconds and echoes its
 * label as "…ing", so a double press reads as one press. The request itself
 * carries a request_id the gem dedupes on; this is the visible half.
 */
export function usePressedEcho(ms = 2000) {
  const [pressed, setPressed] = useState<string | null>(null)
  const timer = useRef<number | null>(null)
  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current)
    },
    [],
  )
  const press = (name: string, run: () => void) => {
    if (pressed) return
    setPressed(name)
    run()
    timer.current = window.setTimeout(() => setPressed(null), ms)
  }
  return { pressed, press }
}

/** One id per click; the server passes it through as the gem's request_id. */
export const requestId = () =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`
